import { render, staticRenderFns } from "./singleCategory.vue?vue&type=template&id=9f956440&"
import script from "./singleCategory.vue?vue&type=script&lang=js&"
export * from "./singleCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports